import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';
import { REGION_SCALE } from '../../BSLAConstants';

const BSLAMesicHammockLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        title: 'Mesic Hammock (Sarasota)',
        url: 'https://utility.arcgis.com/usrsvcs/servers/02322345e22848da88daf1c0e09cf69e/rest/services/MESIC_HAMMOCK_V2/FeatureServer/0',
        visible: false,
        opacity: 0.75,
        minScale: REGION_SCALE,
        popupTemplate: {
            outFields: ['*'],
            title: 'Mesic Hammock (Sarasota)',
            content: (feature: __esri.Feature) => {
                const node = document.createElement('div');

                const content = (
                    <React.Fragment>
                        <div className="mb-3">
                            Hammocks are generally clusters of cabbage palms and/or oak trees forming an overstory. Conditions including moisture (flooding as well as drought) and
                            fire frequency contribute to their formation. The tree canopy must become dense and block light from the forest floor. shade tolerant plants associated
                            with hammocks include ferns, orchids and epiphytes such as bromeliads and Spanish moss. Impacts are generally limited to 25% of the hammock area and
                            setbacks of at least 30 feet are required.
                        </div>
                        <BSLAExternalLinkComponent href="https://www.fws.gov/verobeach/MSRPPDFs/MesicTempHam.pdf" />
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLAMesicHammockLayer;
